<template>
    <transition-group
        v-if="totalPages > 1"
        name="fade-in"
        tag="ul"
        class="pagination"
    >
        <li
            key="prev"
            class="prev"
            :class="{ disabled: pageNumber <= 1 || disabled }"
            @click="!disabled && pageNumber > 1 ? pageNumber-- : pageNumber"
        >
            <span class="icon-angle-left"></span>
        </li>
        <li
            key="minus5"
            :class="{ disabled: pageNumber <= 1 || disabled }"
            @click="trySubtractFive"
        >
            <span>...</span>
        </li>
        <li
            v-show="pageNumber - 2 > 0"
            key="minus2"
            :class="{ disabled: disabled }"
            @click="!disabled && (pageNumber = pageNumber - 2)"
        >
            <span>{{ pageNumber - 2 }}</span>
        </li>
        <li
            v-show="pageNumber - 1 > 0"
            key="minus1"
            :class="{ disabled: disabled }"
            @click="!disabled && pageNumber--"
        >
            <span>{{ pageNumber - 1 }}</span>
        </li>
        <li key="current" class="active">
            <span>{{ pageNumber }}</span>
        </li>
        <li
            v-show="pageNumber + 1 <= totalPages"
            key="plus1"
            :class="{ disabled: disabled }"
            @click="!disabled && pageNumber++"
        >
            <span>{{ pageNumber + 1 }}</span>
        </li>
        <li
            v-show="pageNumber + 2 <= totalPages"
            key="plus2"
            :class="{ disabled: disabled }"
            @click="!disabled && (pageNumber = pageNumber + 2)"
        >
            <span>{{ pageNumber + 2 }}</span>
        </li>
        <li
            key="plus5"
            :class="{ disabled: pageNumber >= totalPages || disabled }"
            @click="tryAddFive"
        >
            <span>...</span>
        </li>
        <li
            key="next"
            class="next"
            :class="{ disabled: pageNumber >= totalPages || disabled }"
            @click="
                !disabled && pageNumber < totalPages ? pageNumber++ : pageNumber
            "
        >
            <span class="icon-angle-right"></span>
        </li>
    </transition-group>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            default: 0
        },
        totalPages: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            pageNumber: 0
        };
    },

    watch: {
        pageNumber(val) {
            this.$emit('input', val);
        },
        value(val) {
            this.pageNumber = val;
        }
    },

    created() {
        this.pageNumber = this.value;
    },

    methods: {
        trySubtractFive() {
            if (!this.disabled && this.pageNumber > 5) {
                this.pageNumber = this.pageNumber - 5;
            } else if (!this.disabled) {
                this.pageNumber = 1;
            }
        },

        tryAddFive() {
            if (!this.disabled && this.pageNumber < this.totalPages - 5) {
                this.pageNumber = this.pageNumber + 5;
            } else if (!this.disabled) {
                this.pageNumber = this.totalPages;
            }
        }
    }
};
</script>
